import { useQuery } from "@tanstack/react-query";
import { Button, Checkbox, Form, Input, Select } from "antd";
import { FC, useEffect, useState } from "react";

import {
  grayPointSVG,
  infoSVG,
  miniGiftCardSVG,
  miniGrayGiftSVG,
  miniGraySelfLove,
  miniWhiteGiftSVG,
  miniWhiteSelfLove,
  trashSVG,
} from "../../../assets/SVGs/SVGs";
import { useDispatch, useSelector } from "react-redux";
import { setGiftCards } from "../../../services/store/slices/cart";
import { bookingGiftCard } from "../../../types/giftCard";
import { PlusSquareOutlined } from "@ant-design/icons";
interface ServicesProps {}

const GiftCards: FC<ServicesProps> = ({}) => {
  //! most logic changed so follow the appointment logic (apis and etc)

  const [showForm, setShowForm] = useState(true);
  const [giftToAnotherPerson, setGiftToAnotherPerson] = useState(true);
  const dispatch = useDispatch();
  const { giftCards } = useSelector(
    (state: { cart: { giftCards: { giftCards: bookingGiftCard[] } } }) =>
      state.cart.giftCards
  );
  const handleDeleteGiftCard = (index: number) => {
    const newGiftCards = giftCards.filter((giftCard, i) => i !== index);
    dispatch(setGiftCards(newGiftCards));
    if (newGiftCards.length === 0) {
      setShowForm(true);
    }
  };
  const giftCardsValues = [
    {
      id: 1,
      value: 500,
    },
    {
      id: 2,
      value: 200,
    },
    {
      id: 3,
      value: 150,
    },
    {
      id: 4,
      value: 100,
    },
  ];
  const options = giftCardsValues.map((giftCard) => {
    return {
      label: (
        <div className="text-color-primary">
          <span>{giftCard.value}</span>{" "}
          <small className="text-xs">ريال سعودي</small>
        </div>
      ),
      value: giftCard.value,
    };
  });
  const onFinish = (values: {
    first_name?: string;
    last_name?: string;
    email: string;
    giftCardValue: number;
    giftMessage: string;
  }) => {
    const newGiftCar: bookingGiftCard = {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      giftCardValue: values.giftCardValue,
      giftMessage: values.giftMessage,
    };
    dispatch(setGiftCards([...giftCards, newGiftCar]));
    setShowForm(false);
  };
  return (
    <div className="shadow p-6 space-y-4 rounded-lg  max-h-[110vh] overflow-y-auto ">
      <div className="space-y-4">
        <h4 className="text-color-primary text-xl ">شراء كارت هدايا</h4>
        <p className="text-color-sec-title">
          قم باستكمال المطلوب من الآتي لشراء كارت الهدايا{" "}
        </p>
      </div>
      <div>
        <p>كروت الهدايا المختارة</p>
      </div>

      {giftCards.length ? (
        <div className="p-2 space-y-2 ">
          {giftCards?.map((giftCard: bookingGiftCard, index) => (
            <div
              key={index}
              className="flex flex-wrap w-full gap-4 justify-between items-center "
            >
              <div className="min-w-[70%] bg-[#eff1f05c] p-2 rounded-lg flex justify-between gap-2 items-center text-color-primary">
                <span>
                  {miniGiftCardSVG} <span className="mx-1">كارت هدايا</span>
                </span>
                <span>{grayPointSVG}</span>
                <span>
                  {giftCard?.first_name} {giftCard?.last_name}
                </span>
                <span>{grayPointSVG}</span>
                <span>
                  {giftCard?.giftCardValue} <small>ريال</small>
                </span>
                <Button
                  htmlType="button"
                  onClick={() => handleDeleteGiftCard(index)}
                >
                  {trashSVG}
                </Button>
              </div>
              {index === giftCards.length - 1 && !showForm ? (
                <Button
                  htmlType="button"
                  className=""
                  onClick={() => setShowForm(true)}
                  icon={<PlusSquareOutlined />}
                >
                  كارت هدايا جديد
                </Button>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
      <div>
        {showForm ? (
          <div>
            <div className="space-y-2">
              <p className="text-color-primary">اهداء الكارت الى:</p>
              <div className="flex w-full    ">
                <div
                  onClick={() => setGiftToAnotherPerson(true)}
                  className={
                    giftToAnotherPerson
                      ? "rounded-s-lg  bg-color-primary text-white  cursor-pointer p-2 flex gap-1  justify-center items-center w-full"
                      : "rounded-s-lg bg-[#CFCFE2] cursor-pointer p-2 flex justify-center gap-1  items-center w-full"
                  }
                >
                  <span>
                    {giftToAnotherPerson ? miniWhiteGiftSVG : miniGrayGiftSVG}
                  </span>
                  <span>الشراء لشخص آخر</span>
                </div>
                <div
                  onClick={() => setGiftToAnotherPerson(false)}
                  className={
                    !giftToAnotherPerson
                      ? " rounded-e-lg  bg-color-primary text-white cursor-pointer p-2 flex gap-1 justify-center items-center w-full "
                      : " rounded-e-lg bg-[#CFCFE2] cursor-pointer p-2 flex justify-center gap-1  items-center w-full"
                  }
                >
                  <span>
                    {giftToAnotherPerson ? miniGraySelfLove : miniWhiteSelfLove}
                  </span>
                  <span>لنفسي</span>
                </div>
              </div>
              <div>
                <Form layout="vertical" onFinish={onFinish}>
                  {giftToAnotherPerson ? (
                    <div className="flex justify-between items-center gap-2">
                      <Form.Item
                        className="w-full"
                        colon={false}
                        required={false}
                        name={"first_name"}
                        label="الاسم الأول"
                        rules={[
                          {
                            required: true,
                            message: "برجاء ادخال الاسم الأول",
                          },
                        ]}
                      >
                        <Input placeholder="الاسم الأول" />
                      </Form.Item>
                      <Form.Item
                        className="w-full"
                        colon={false}
                        required={false}
                        name={"last_name"}
                        label="اسم العائله"
                        rules={[
                          {
                            required: true,
                            message: "برجاء ادخال اسم العائله",
                          },
                        ]}
                      >
                        <Input placeholder="اسم العائله" />
                      </Form.Item>
                    </div>
                  ) : null}
                  <div className="flex justify-between items-center gap-2">
                    <Form.Item
                      className="w-full"
                      colon={false}
                      required={false}
                      name={"email"}
                      label="ارسال الى:"
                      rules={[
                        {
                          required: true,
                          message: "برجاء ادخال البريد الإلكتروني",
                        },
                        {
                          type: "email",
                          message: "بريد الإلكتروني غير صحيح",
                        },
                      ]}
                    >
                      <Input placeholder="البريد الإلكتروني" />
                    </Form.Item>
                    <Form.Item
                      className="w-full"
                      colon={false}
                      required={false}
                      name={"giftCardValue"}
                      label="قيمة الكارت"
                      rules={[
                        {
                          required: true,
                          message: "برجاء إختيار قيمة الكارت",
                        },
                      ]}
                    >
                      <Select options={options} />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      className="w-full"
                      colon={false}
                      required={false}
                      name={"giftMessage"}
                      label="رسالة مع كارت الهدية"
                    >
                      <Input.TextArea placeholder="ادخل الرسالة" rows={5} />
                    </Form.Item>
                  </div>
                  <div className="text-center p-2">
                    <div className="flex justify-center gap-1 items-start">
                      <span>{infoSVG}</span>
                      <p>
                        سيتم ارسال تفاصيل كارت الهدايا الى المستفيد مباشرة بعد
                        الدفع
                      </p>
                    </div>
                  </div>
                  <Form.Item>
                    <Button
                      className="mt-2 w-full bg-[#EEF0FF] text-color-primary font-semibold"
                      htmlType="submit"
                      size="large"
                    >
                      اضافة الكارت
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default GiftCards;
